import React from 'react'
import AccountSetup from '../../accounts/Layout'

export default function TTDSignup() {
  return <AccountSetup />
}
